import React, { ReactNode } from 'react';
import { v1 } from 'uuid';
import useKeyboardKey from 'helpers/hooks/useKeyboardKey';
import { KEY_BINDINGS } from 'shared/interface/globalInterface';

import './_FullScreenModal.scss';

type Props = {
  title?: string;
  infos: ReactNode[];
  onClose: () => void;
  wrapperClass?: string | null;
};

const FullScreenModal: React.FC<Props> = ({ title, infos, onClose, wrapperClass, children }) => {
  useKeyboardKey(KEY_BINDINGS.ESC, onClose);

  return (
    <>
      <div className="overlay" onClick={onClose}></div>
      <div className={`modal modal-info ${wrapperClass}`}>
        {title && (
          <div className="modal__header">
            <h1>{title}</h1>
          </div>
        )}

        <div className="modal__content">
          {infos.map((info) => {
            const id = v1();
            return <React.Fragment key={id}>{info}</React.Fragment>;
          })}
          {children}
        </div>
      </div>
    </>
  );
};

export default FullScreenModal;
